export const editorialStatuses = [
  'documentado', 'confirmado-pelo-citado', 'em-investigacao', 'denunciado',
  'acusacao-contestada', 'decisao-processual', 'provas-anuladas',
  'arquivado-ou-rejeitado', 'condenacao-nao-definitiva', 'condenacao-definitiva',
  'sem-comprovacao-suficiente', 'informacao-falsa-ou-imprecisa',
] as const

export type EditorialStatus = typeof editorialStatuses[number]
export type Category = 'dinheiro' | 'investigacao' | 'relacoes' | 'patrimonio' | 'declaracoes' | 'eleicoes' | 'direitos' | 'trabalho' | 'servicos-publicos' | 'meio-ambiente' | 'povos-indigenas' | 'soberania'

export type TimelineEvent = { date: string; title: string; summary: string; status: EditorialStatus; sourceIds: string[] }
export type EvidenceItem = { title: string; summary: string; sourceIds: string[] }
export type DefenseItem = { person: string; summary: string; date?: string; sourceIds: string[] }
export type EditorialPoint = { title: string; analysis: string; sourceIds: string[] }
export type EditorialReading = { headline: string; summary: string; points: EditorialPoint[] }
export type DailyImpact = { headline: string; summary: string; areas: string[] }
export type DocumentChainItem = { title: string; relation: string; note: string; sourceIds: string[]; certainty: 'comprovado' | 'associacao-documentada' | 'nao-comprovado' }

export type CaseRecord = {
  documentary?: import('./content/schemas').Documentary
  investigation?: import('./content/schemas').Investigation
  id: string; slug: string; title: string; shortTitle: string; dek: string; summary30s: string
  whyItMatters: string; notProven: string[]; category: Category; editorialStatus: EditorialStatus
  statusProcessual: string; statusAsOf: string; firstEventAt?: string; lastEventAt?: string
  amounts?: Array<{ value: number; currency: string; label: string; period: string; sourceIds: string[] }>
  peopleIds: string[]; institutionIds: string[]; timeline: TimelineEvent[]; evidence: EvidenceItem[]
  defenses: DefenseItem[]; sources: string[]; relatedCaseIds: string[]; tags: string[]
  lastVerifiedAt: string; editorialReading: EditorialReading; editorialNotes?: string
  dailyImpact: DailyImpact; processDecided: string; processDidNotDecide: string; openQuestions: string[]
  statementIds: string[]; secondaryTimeline?: { title: string; intro: string; events: TimelineEvent[] }
  documentChain?: DocumentChainItem[]; attributedCapabilities?: string[]
}

export type SourceRecord = {
  verification?: 'texto-consultado' | 'registro-indexado' | 'acesso-limitado'
  id: string; title: string; publisher: string; url: string; publishedAt?: string; accessedAt: string
  sourceType: 'decisao' | 'documento-oficial' | 'plano-de-governo' | 'lei' | 'sessao' | 'reportagem' | 'video' | 'audio' | 'nota-da-defesa' | 'checagem' | 'analise' | 'opiniao'
  sourceTier: 1 | 2 | 3; archiveUrl?: string; relevantExcerptSummary: string
}

export type PersonRecord = { id: string; name: string; role: string; note: string }
export const statementClassifications = [
  'contradicao-direta', 'versao-modificada', 'afirmacao-incompleta',
  'questao-ainda-aberta', 'alegacao-nao-confirmada',
  'mudanca-de-versao', 'choque-com-os-documentos', 'contexto-contestado',
] as const
export type StatementClassification = typeof statementClassifications[number]
export type StatementRecord = {
  id: string; slug: string; title: string; shortTitle: string; classifications: StatementClassification[]
  before: StatementMoment; after: StatementMoment; whatChanged: string; response: string; sourceIds: string[]; lastVerifiedAt: string
}
export type StatementMoment = {
  date: string; label: string; transcript: string; verifiedAsDirectQuote: boolean; mediaType: 'video' | 'document' | 'report'
  videoUrl?: string; videoId?: string; timestamp?: number; context: string; sourceId: string
}
export type ConversationEntry = {
  id: string; threadId: string; date: string; dateLabel?: string; time?: string; sender: string; recipient?: string
  kind: 'text' | 'audio-transcript' | 'document' | 'editorial-summary'; text?: string; summary?: string
  sourceIds: string[]; sourceLocator: string; verifiedAsDirectQuote: boolean
  whatItShows: string; whatItDoesNotShow: string; act?: 1 | 2 | 3
}
export type CorrectionRecord = {
  id: string; circulatingVersion: string; verdict: 'falso' | 'impreciso' | 'nao-sustentado'
  wrongOrImprecise: string; documentsShow: string; whyRelevant: string; sourceIds: string[]; lastVerifiedAt: string
}
export type RelationRecord = {
  id: string; people: string[]; documentedAct: string; date: string; sourceIds: string[]; responses: string
  whyItMatters: string; cannotConclude: string; openQuestion: string
}
